
export enum Role {
  ROLE_ADMIN = 'ROLE_ADMIN',
  ROLE_EXPERT = 'ROLE_EXPERT',
  ROLE_FIELD = 'ROLE_FIELD',
}

export enum RoleLocalization {
  ROLE_ADMIN = 'Company administrator',
  ROLE_EXPERT = 'Expert',
  ROLE_FIELD = 'Field Operator',
}
